
import QueryMethods from '@/components/atoms/QueryMethods.vue'
import { Component, Mixins, Vue } from 'vue-property-decorator'
import { AlignedCourses, StandardCourses } from '@/store/modules/StudentCreationInfo'

@Component
export default class StudentIdsInfo extends Mixins(QueryMethods) {
  protected userIds = []
  protected schoolOptions: { text: string; value: number }[] = []
  protected branchId = Vue.prototype.$cookies.get('dataGdls').branchId
  protected academyId = Vue.prototype.$cookies.get('dataGdls')?.academyId

  protected setParamsFromQuery() {
    const params = this.getParamsObject()
    if (params['id']) {
      this.userIds = params['id'].split(',')
    }
  }

  protected get isMultiStudent() {
    return this.userIds.length > 1
  }

  protected async loadSchools() {
    await Vue.prototype.$http.httpWithToken
      .get(`/schools`, { params: { branchId: this.branchId } })
      .then((res: any) => {
        this.schoolOptions = res.data.schools.map((school: { id: number; name: string }) => {
          return {
            text: school.name,
            value: school.id,
          }
        })
      })
  }

  protected isChooseStandardCourses(standardCourses?: StandardCourses | null) {
    if (!standardCourses) return false
    return Object.values(standardCourses).some((courseSubject) => {
      return courseSubject
    })
  }

  protected isChooseAlignedCourses(alignedCourses?: AlignedCourses | null) {
    if (!alignedCourses) return false
    return Object.values(alignedCourses).some((courseSubject) => {
      return Object.values(courseSubject).some((course) => {
        return course.checked
      })
    })
  }
}
